import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenInventoryPageBreadcrumbs } from '@/pages/Inventory/config';
import { NavigateFunction } from 'react-router-dom';

export const departmentsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Ubicaciones', onClick: () => navigate('/inventory/geography') },
];

export const childrenDepartmentsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Ubicaciones', onClick: () => navigate('/inventory/geography') },
];
export const createDepartmentsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenDepartmentsPageBreadcrumbs(navigate),

  {
    label: 'Departamentos',
    onClick: () => navigate('/inventory/geography/departments'),
  },
];
